import { StorageUtil } from '../../../shared/utils/storage';
import {
  V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY,
  V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY_COMPANY,
} from '../helpers/helper';

export type RecentSearchStorageKey =
  | typeof V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY
  | typeof V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY_COMPANY;

/**
 * Get recent searches for a user
 * @param userEmail - User's email
 * @param storageKey - Storage key for people (default) or company tab
 */
export const getRecentSearches = (
  userEmail: string,
  storageKey: RecentSearchStorageKey = V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY,
): any[] => {
  try {
    const stored = StorageUtil.getItem(storageKey);
    if (!stored) return [];
    const allSearches = JSON.parse(stored) || {};
    return allSearches[userEmail] || [];
  } catch (error) {
    return [];
  }
};

/**
 * Save recent searches for a user
 * @param userEmail - User's email
 * @param searches - Array of recent searches
 * @param storageKey - Storage key for people (default) or company tab
 */
export const saveRecentSearches = (
  userEmail: string,
  searches: any[],
  storageKey: RecentSearchStorageKey = V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY,
): void => {
  try {
    const allSearches = JSON.parse(
      StorageUtil.getItem(storageKey) || '{}',
    );
    allSearches[userEmail] = searches;
    StorageUtil.setItem(storageKey, JSON.stringify(allSearches));
  } catch (error) {
    // Silently fail if storage is not available
  }
};

/**
 * Clear all recent searches from storage
 * @param storageKey - Storage key for people (default) or company tab. If not provided, clears both.
 */
export const clearRecentSearches = (
  storageKey?: RecentSearchStorageKey,
): void => {
  try {
    if (storageKey) {
      StorageUtil.removeItem(storageKey);
    } else {
      StorageUtil.removeItem(V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY);
      StorageUtil.removeItem(V2_LEAD_FINDER_RECENT_SEARCHES_STORAGE_KEY_COMPANY);
    }
  } catch (error) {
    // Silently fail if storage is not available
  }
};
